import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getPayments } from "api/payment.api";
import { gracefulList } from "lib/queryHelpers";
import { QUERY_KEYS } from "config/queryKeys";
import { DEFAULT_STALE_TIME } from "config/constants";

const paymentsListKey = () =>
  QUERY_KEYS?.payments?.list?.() || ["payments", "list"];

export const useGetPayments = () => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: paymentsListKey(),
    queryFn: gracefulList(getPayments, { payments: [] }),
    initialData: () => queryClient.getQueryData(paymentsListKey()),
    select: (data) => data?.payments ?? [],
    staleTime: DEFAULT_STALE_TIME,
  });
};
